export const CLEAR_STATE = 'BAG_SIZE.CREATE.CLEAR_STATE';
export const RESET_ERROR = "BAG_SIZE.CREATE.RESET_ERROR";